<template>
  <div class="form-container">
    <van-form>
      <div class="card-box">
        <div class="left">身份证上传</div>
        <div class="right">
          <label v-show="idCardIsUpload">上传成功</label>
          <img
            @click="handleIdCardClick(1)"
            v-show="!idCardIsUpload"
            :src="require('@/assets/imgs/upload/upload_before.svg')"
            class="upload-before"
            style="top: -10px"
          />
          <img
            @click="handleIdCardClick(1)"
            v-show="idCardIsUpload"
            :src="require('@/assets/imgs/upload/upload_after.svg')"
            class="upload-before"
          />
          <input
            type="file"
            ref="rfile1"
            @change="handleUploadChange($event, 1)"
            style="display: none"
            accept="image/*"
          />
        </div>
      </div>

      <van-field
        v-model="dataForm.insureIdNo"
        name="被保人身份证"
        label="被保人身份证"
        placeholder="请输入被保人身份证"
        v-on:input="
          dataForm.insureIdNo = dataForm.insureIdNo.replace(/[^\d|X|x]/g, '')
        "
      />
      <van-field
        v-model="dataForm.insureName"
        name="被保人姓名"
        label="被保人姓名"
        placeholder="被保人姓名"
      />
      <van-field
        v-model="dataForm.engineNo"
        name="电动机号"
        label="电动机号"
        placeholder="请输入电动机号"
      />
      <van-field
        v-model="dataForm.vinNo"
        name="车架号"
        label="车架号"
        placeholder="请输入车架号"
      />
      <van-field
        readonly
        clickable
        name="保险产品"
        label="保险产品"
        :value="productValue"
        placeholder="请选择"
        @click="showProductPicker = true"
      />
      <van-cell
        title="保障项目"
        is-link
        @click="showInfo = !showInfo"
        value="点击查看"
        :arrow-direction="showInfo ? 'down' : ''"
      />
    </van-form>
    <div class="productinfo-view" v-show="showInfo">
      <div
        class="productinfo-item"
        v-for="(item, index) in infoOptions"
        :key="index"
      >
        <div class="title">《{{ item.name }}》</div>
        <div class="content-box">
          <div class="left">{{ item.show }}</div>
          <div class="right">
            <div
              class="right-item"
              v-for="(name, idx) in item.contentList"
              :key="idx"
            >
              {{ name }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 5rem"></div>
    <div class="button-save">
      <van-button @click="handleGoClick" type="primary" block color="#fe5958"
        >立即投保</van-button
      >
    </div>
    <div class="overlay-box">
      <van-overlay :show="showLoading">
        <div class="wrapper">
          <div class="loadding-box">
            <van-loading type="spinner" color="white" />上传中
          </div>
        </div>
      </van-overlay>
    </div>
    <van-popup v-model="showProductPicker" position="bottom">
      <van-picker
        show-toolbar
        value-key="name"
        :columns="productLists"
        @confirm="handleProductPickerOk"
        @cancel="showProductPicker = false"
      />
    </van-popup>
    <a href="tel:18595961771" v-show="false" ref="tels"></a>
  </div>
</template>

<script>
import switchs from "@/components/switch";
import { isMobile, isCard } from "@/utils/validate";
import {
  uploadIdCard,
  uploadCarCard,
  createElectroInsure,
  getJsapiTicket,
  findCategoryByProductId,
} from "@/api/common";
import qs from "qs";
import { Notify } from "vant";
import { Dialog } from "vant";
import { Toast } from "vant";
export default {
  components: { switchs },
  data() {
    return {
      minDate: new Date(2000, 0, 1),
      maxDate: new Date(),
      currentDate: "",
      showProductPicker: false,
      showConfirm: false,
      idCardIsUpload: false,
      dataForm: {
        insureIdNo: "",
        insureName: "",
        categoryId: "",
        engineNo: "",
        platformId: "",
        belongerId: "",
        vinNo: "",
      },
      productValue: "",
      showLoading: false,
      productOptions: [],
      productLists: [],
      showInfo: false,
      infoOptions: [],
    };
  },
  created() {
    this.dataForm.belongerId = this.$route.query.belongerId || "";
    this.dataForm.platformId = this.$route.query.platformId || "";
    document.title = "电车险";
    this._findCategoryByProductId();
  },
  mounted() {
    let sUrl = location.href.split("#")[0];
    let sImgUrl = "http://nywx.e-ibdt.cn/file/logo/logo_picc.png";
    getJsapiTicket({ appid: process.env.WXKey, url: sUrl }).then((res) => {
      if (res.code === 0) {
        this.$ComTools.wxShare(
          res.data,
          sUrl,
          sImgUrl,
          "电车险"
        );
      }
    });
  },
  methods: {
    _findCategoryByProductId() {
      this.productOptions = [];
      this.productLists = [];
      findCategoryByProductId({ productId: 300 }).then((res) => {
        if (res.code == 0) {
          this.productOptions = res.data.list;
          for (let i = 0; i < this.productOptions.length; i++) {
            let oProduct = this.productOptions[i];
            if (this.itemindex == oProduct.id) {
              this.productValue = oProduct.allName;
              this.setValue(oProduct);
            }
            this.productLists.push(this.$ComTools.assertOfDepth(oProduct));
          }
        }
      });
    },
    handleProductPickerOk(a) {
      this.productValue = a.name;
      this.showProductPicker = false;
      this.dataForm.categoryId = a.id;
      let sClauseJson = a.clauseJson;
      if (!this.$ComTools.isEmptyString(sClauseJson)) {
        let aClauseJson = JSON.parse(sClauseJson);
        let aTmp = [];
        for (let i = 0; i < aClauseJson.length; i++) {
          let item = aClauseJson[i];
          let sContent = item.content;
          item.contentList = [];
          if (!this.$ComTools.isEmptyString(sContent)) {
            item.contentList = sContent.split(",");
          }
          aTmp.push(item);
        }
        this.infoOptions = aTmp;
      }
    },
    handleIdCardClick(index) {
      if (index === 1) {
        this.$refs.rfile1.click();
      } else {
        this.$refs.rfile2.click();
      }
    },
    handleUploadChange(e, index) {
      let oFile = e.target.files[0];
      let fd = new FormData();
      fd.append("file", oFile);
      this.showLoading = true;
      switch (index) {
        case 1:
          uploadIdCard(fd).then((res) => {
            this.$refs.rfile1.value = null;
            this.showLoading = false;
            this.idCardIsUpload = true;
            if (
              res.code === 0 &&
              !this.$ComTools.isEmptyString(res.data.result)
            ) {
              this.dataForm.insureIdNo = res.data.result.number;
              this.dataForm.insureName = res.data.result.name;
            }
          });
          break;
      }
    },
    handleCallClick() {
      this.$refs.tels.click();
    },
    handleGoClick() {
      if (this.$ComTools.isEmptyString(this.dataForm.insureIdNo)) {
        return Notify("被保人身份证号不能为空");
      }
      if (!isCard(this.dataForm.insureIdNo)) {
        return Notify("被保人身份证格式错误");
      }
      if (this.$ComTools.isEmptyString(this.dataForm.insureName)) {
        return Notify("被保人姓名不能为空");
      }
      if (
        this.$ComTools.isEmptyString(this.dataForm.engineNo) &&
        this.$ComTools.isEmptyString(this.dataForm.vinNo)
      ) {
        return Notify("电动机号和车架号不能同时为空");
      }
      if (this.$ComTools.isEmptyString(this.dataForm.categoryId)) {
        return Notify("请选择产品");
      }
      Toast.loading({
        message: "投保中...",
        forbidClick: true,
        duration: 0,
      });
      createElectroInsure(this.dataForm).then((res) => {
        Toast.clear();
        if (res.code === 0) {
          var paymentMap = res.data;
          if (typeof WeixinJSBridge === "undefined") {
            if (document.addEventListener) {
              document.addEventListener(
                "WeixinJSBridgeReady",
                this.$ComTools.onBridgeReady(paymentMap, this.payCallback),
                false
              );
            } else if (document.attachEvent) {
              document.attachEvent(
                "WeixinJSBridgeReady",
                this.$ComTools.onBridgeReady(paymentMap, this.payCallback)
              );
              document.attachEvent(
                "onWeixinJSBridgeReady",
                this.$ComTools.onBridgeReady(paymentMap, this.payCallback)
              );
            }
          } else {
            this.$ComTools.onBridgeReady(paymentMap, this.payCallback);
          }
        } else {
          Notify({ type: "danger", message: res.msg });
        }
      });
    },
    payCallback(index) {
      switch (index) {
        case 1:
          this.$router.push({
            path: "/insure/list",
          });
          break;
        case 2:
          Toast("取消支付");
          WeixinJSBridge.call("closeWindow");
          break;
        case 3:
          Toast("支付失败");
          WeixinJSBridge.call("closeWindow");
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.form-container {
  width: 100%;
  min-height: 100%;
  .card-box {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.8rem 1.2rem 0.8rem 1rem;
    background-color: #efeff4;
    .left {
      font-size: 1rem;
      font-weight: 600;
    }
    .right {
      display: flex;
      align-items: center;
      position: relative;
      label {
        color: #fe5958;
        margin-right: 4rem;
      }
      .upload-before {
        height: 2rem;
        width: 2rem;
        position: absolute;
        right: 0;
        top: -2px;
      }
    }
  }
  .switch-box {
    position: absolute;
    right: 10px;
    top: 10px;
  }
  .button-save {
    /deep/ .van-button {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }
  .overlay-box {
    /deep/ .van-overlay {
      background-color: transparent;
    }
  }

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .loadding-box {
      width: 6rem;
      background-color: rgba(0, 0, 0, 0.7);
      height: 5rem;
      color: white;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      border-radius: 5px;
      padding: 0.6rem 0;
    }
  }
  .productinfo-view {
    padding: 10px 16px;
    .productinfo-item {
      border: 1px solid #e3e1e2;
      border-bottom: none;
      &:first-child {
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
      }
      &:last-child {
        border-bottom: 1px solid #e3e1e2;
        border-bottom-left-radius: 3px;
        border-bottom-right-radius: 3px;
      }
      .title {
        width: 100%;
        text-align: center;
        padding: 8px 0;
        background-color: #f2f2f2;
        font-size: 0.8rem;
        color: #4caaf7;
        border-bottom: 1px solid #e3e1e2;
      }
      .content-box {
        width: 100%;
        // display: flex;
        // align-items: center;
        display: flex;
        .left {
          width: 30%;
          text-align: center;
          font-size: 0.8rem;
          color: #5e5e5e;
          padding: 5px 10px;
          display: flex;
          align-items: center;
        }
        .right {
          width: 70%;
          display: flex;
          flex-direction: column;
          border-left: 1px solid #e3e1e2;
          justify-content: center;
          .right-item {
            text-align: center;
            padding: 10px 0;
            border-bottom: 1px solid #e3e1e2;
            font-size: 0.8rem;
            color: #5e5e5e;
            &:last-child {
              border-bottom: none;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/insurance/electric_form.vue